export enum CustomNotificationLocation {
    EXTENSION = "extension",
    PUBLIC_PAGES = "public-pages",
    USER_DASHBOARD = "user-dashboard"
}